export const loadQueuesMutation = (state, queuesArray) => {
    state.queues = queuesArray;
};
